import { Config } from '../../../../config';
import axios from 'axios';
const ByodPhoneNumberGroupingApiUrl = `${Config.url.PLAN_URL}/api/v1/ByodPhoneNumberGrouping`;

export interface IByodPhoneNumberGrouping {
    areaCode: number;
    prefix?: number;
    suffix?: number;
}

const GetByodPhoneNumbers = (
    onSuccess: (phoneNumbers: IByodPhoneNumberGrouping[]) => void,
    onFailure: () => void
) => {
    axios.get(ByodPhoneNumberGroupingApiUrl).then((response) => {
        onSuccess(response.data);
    }, onFailure);
};

export default GetByodPhoneNumbers;
